/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetGipReportExportStatusQueryResponse, GetGipReportExportStatusPathParams, GetGipReportExportStatus404 } from "../models/GetGipReportExportStatus";

export function getGetGipReportExportStatusUrl(id: GetGipReportExportStatusPathParams["id"]) {
  const res = { method: 'GET', url: `/reports/gip/report/${id}/export-status` as const }
  return res
}

/**
 * @summary Get export job status for report
 * {@link /reports/gip/report/:id/export-status}
 */
export async function getGipReportExportStatus(id: GetGipReportExportStatusPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetGipReportExportStatusQueryResponse, ResponseErrorConfig<GetGipReportExportStatus404>, unknown>({ method : "GET", url : getGetGipReportExportStatusUrl(id).url.toString(), ... requestConfig })
  return res.data
}